const adminViewStyle = {
  backgroundPosition: "left top",
  backgroundRepeat: "no-repeat",
  backgroundImage: "url(/static/dashboard/left-top-bg.png)",
};

export { adminViewStyle };
